module.exports = __webpack_public_path__ + "static/media/apo.72288694.jpg";